import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errorMessage } from "../../lib/api";
import { Switch } from "../ui/switch";

export const ServiceRates = () => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { adminApi.get("/admin/hk/services").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items) return null;
  const set = (key, k, v) => setItems((xs) => xs.map((x) => (x.key === key ? { ...x, [k]: v } : x)));
  const save = () => {
    setBusy(true);
    adminApi.put("/admin/hk/services", { items: items.map((x) => ({ key: x.key, price: Number(x.price) || 0, active: x.active !== false, includes: x.includes })) })
      .then((r) => { setItems(r.data); toast.success("Rates saved"); }).catch((e) => toast.error(errorMessage(e))).finally(() => setBusy(false));
  };
  return (
    <section data-testid="hk-rates" className="space-y-3">
      <p className="text-sm text-slate-400">Set ₹0 to show "Price on request" (you send a custom quote for each booking). Turn a service off to hide it from customers.</p>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
        {items.map((s) => (
          <div key={s.key} className="space-y-2 border border-white/10 px-3 py-2 text-sm">
          <div className="flex items-center justify-between gap-3">
            <span className="min-w-0"><span className="block truncate text-white">{s.label}</span><span className="text-xs text-slate-500">{s.group}{s.unit_label ? ` · per ${s.unit_label}` : ""}</span></span>
            <span className="flex shrink-0 items-center gap-2">
              ₹<input value={s.price} onChange={(e) => set(s.key, "price", e.target.value.replace(/\D/g, "").slice(0, 7))} data-testid={`hk-rate-input-${s.key}`}
                className="h-8 w-24 border border-white/15 bg-[#0B1120] px-2 font-mono" />
              <Switch checked={s.active !== false} onCheckedChange={(v) => set(s.key, "active", v)} data-testid={`hk-rate-active-${s.key}`} className="data-[state=checked]:bg-emerald-500 data-[state=unchecked]:bg-slate-600" />
            </span>
          </div>
          <textarea value={(s.includes || []).join("\n")} onChange={(e) => set(s.key, "includes", e.target.value.split("\n").slice(0, 10))} rows={3}
            data-testid={`hk-includes-input-${s.key}`} placeholder="What's included (one per line)" className="w-full border border-white/10 bg-[#0B1120] px-2 py-1 text-xs text-slate-300" />
          </div>
        ))}
      </div>
      <button disabled={busy} onClick={save} data-testid="hk-rates-save" className="bg-orange-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-orange-600 disabled:opacity-60">Save rates</button>
    </section>
  );
};
